//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
export default {
  data() {
    return {
      orderInfo:'',
      orderinfo:'',
      orderType:this.$route.query.selecttype?this.$route.query.selecttype:'',
      createtime:'',
      buytime:'',
      overtime:'',
      cities : ["能力强","负责任","有问必答","不予理睬","不满意","服务态度好"],
      judgeInfo:'',
      arr : [],
      star: 5,
      docid: "",
      item: {},
      datalist: "",
      skillname: [],
      counts: "",
      isbuy: 0,
      istrue: 0
    };
  },
  methods: {
    updateTop(){
      window.scroll(0,0);
    },
    checkedBox(i) {
      if(this.arr.indexOf(i)!=-1){
        this.arr.splice(this.arr.indexOf(i),1);
      } else {
        if(this.arr.length>3){
          this.arr.splice(3,1);
        }
        this.arr.unshift(i);
      }
    },
    submit(){
      let params={};
      let selecttype=this.$route.query.selecttype;
      if(selecttype=='WZ'){
        if(this.orderinfo.isComment=="1"){
          this.$toastMsg('此问诊订单已评论，请勿重复评论');
          return
        };
        params = {
          doctorId: this.orderinfo.doctorid,
          orderId:this.orderinfo.id,
          createby:this.orderinfo.patientid,
          patientId:this.orderinfo.patientid,
          score:this.star,
          commentlabelCode:this.arr,
          content:this.judgeInfo
        };
      }else{
        if(this.orderInfo.isComment=="1"){
          this.$toastMsg('此处方订单已评论，请勿重复评论');
          return
        };
        params = {
          doctorId: this.orderInfo.doctorId,
          orderId:this.orderInfo.id,
          createby:this.orderInfo.patientId,
          patientId:this.orderInfo.patientId,
          score:this.star,
          commentlabelCode:this.arr,
          content:this.judgeInfo
        };
      }

      let _this=this;
      this.$doRequest("/api/judge/insertJudgeSelective", params, res=>{
        if(res.result==1){
          _this.$toastMsg('提交成功');
          _this.$router.push({path:'/myManage',});
        }else{
          _this.$toastMsg('输入异常，请重新提交');
        }

      })
    },
    getBiaoqian(){
      this.$doRequest("/api/judge/getJudgeCommentlabel", {}, res=>{
        this.cities=res.parameters;
      })
    },
    query(){
      this.getBiaoqian();
      let id=this.$route.query.id;
      let selecttype=this.$route.query.selecttype;
      let params={};
      if(selecttype=='WZ'){
        params ={
          getOrder: '1',
          /*订单id*/
          orderID: id,
          /*是否获取医生详情信息 1 获取2 不获取*/
          getDoctor: '1',
          /*是否获取问诊单  1 获取2 不获取*/
          isInterrogationsingle: '1',
          /*问诊单   1只获取选择的答案2只获取不选择的答案 不传获取全部 */
          ischecked: '1',
        }
      }else{
        params ={
          /*是否获取医生详情信息 1 获取2 不获取*/
          getDoctor: '1',
          /*是否获取患者详情信息 1 获取2 不获取*/
          getPatient: '1',
          /*是否获取主诉  1 获取2 不获取*/
          isaction: '1',
          /*是否获取此订单的药方订单详细信息 1 获取2 不获取*/
          getPrescriptionOrder: '1',
          /*药方订单id，如果想获取问诊订单下面的所有药方订单，此处可不传*/
          prescriptionOrderId: id,
        }
      }

      this.$doRequest("/api/Inquiry/orderDetails", params, res=>{
        this.datalist=res.doctor;
        if(this.orderType=='WZ'){
          this.orderinfo=res.orderinfo;
          var shijianchuo1=this.orderinfo.buytime;
          var time1 = new Date(shijianchuo1);
          var y1 = time1.getFullYear();
          var m1 = time1.getMonth()+1;
          var d1 = time1.getDate();
          var h1 = time1.getHours()+1;
          var mm1 = time1.getMinutes()+1;
          var s1 = time1.getSeconds()+1;
          this.buytime=(y1+'年'+m1+'月'+d1+'日');
          var shijianchuo2=this.orderinfo.updatetime;
          var time2 = new Date(shijianchuo2);
          var y2 = time2.getFullYear();
          var m2 = time2.getMonth()+1;
          var d2= time2.getDate();
          var h2 = time2.getHours()+1;
          var mm2 = time2.getMinutes()+1;
          var s2 = time2.getSeconds()+1;
          this.overtime=(y2+'年'+m2+'月'+d2+'日');
        }else{
          this.orderInfo = res.orderprescriptioninfos[0];//订单信息（药方订单信息)
          var shijianchuo=res.orderprescriptioninfos[0].createtime;
          var time = new Date(shijianchuo);
          var y = time.getFullYear();
          var m = time.getMonth()+1;
          var d = time.getDate();
          var h = time.getHours()+1;
          var mm = time.getMinutes()+1;
          var s = time.getSeconds()+1;
          this.createtime=(y+'-'+m+'-'+d);
        }


      })
    }
  },

  //生命周期之挂载完成
  mounted: function() {
  },
  //生命周期之创建完成
  created: function() {
    document.title = '订单评价';
    this.$isLogin(window.location.search.substr(1), this.query);

  },
  //生命周期之更新
  updated: function() {},
  //生命周期之销毁
  destroyed: function() {},
  watch: {
    istrue: function(value, newvalue) {
      this.istrue = value;
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/judgement/index.vue